var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewGuidelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.495917,
    height: 15.496729,
    viewBox: "0 0 15.495917 15.496729",
    fill: "none",
    id: "svg597",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs601"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 15.463994,2.745089 c -0.0078,-0.12363 -0.0568,-0.24106 -0.1393,-0.3335 -0.0825,-0.09244 -0.1936,-0.15454 -0.3155,-0.17636 -2.9921,-0.53684 -4.2411,-0.92494 -7.0332704,-2.186106 C 7.9042936,0.016746 7.8265836,0 7.7479736,0 c -0.07861,0 -0.15632,0.016746 -0.22795,0.049123 -2.79213,1.261166 -4.04119,1.649266 -7.03325,2.186106 -0.12194,0.02182 -0.23304,0.08392 -0.315503,0.17636 -0.082468,0.09244 -0.131539,0.20987 -0.139357,0.3335 -0.133173,2.11382 0.150813,4.08339 0.84504,5.85407 0.5685,1.44432 1.40984,2.76562 2.47805,3.89172 1.84954,1.9623 3.81324,2.8146 4.18785,2.9655 0.13312,0.0538 0.28196,0.0538 0.41508,0 0.37462,-0.1509 2.3382604,-1.0032 4.1878604,-2.9655 1.0665,-1.1265 1.9061,-2.4478 2.4732,-3.89172 0.6942,-1.77068 0.9782,-3.74025 0.845,-5.85407 z",
    fill: "#5a52c3",
    id: "path237"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect241",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.894409
    },
    d: "M 7.1484375,4.9082031 V 7.1484375 H 4.9082031 V 8.3496094 H 7.1484375 V 10.589844 H 8.3476562 V 8.3496094 H 10.587891 V 7.1484375 H 8.3476562 V 4.9082031 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewGuidelineIcon);
export default __webpack_public_path__ + "static/media/newGuidelineIcon.fa6cef6e0a7971057ef09df43962f3b1.svg";
export { ForwardRef as ReactComponent };